/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

// ============================================================================
// RATE LIMIT EVENT SYSTEM
// ============================================================================

import { logger } from "@/lib/utils/logger";

type Listener = (state: RateLimitState | null) => void;

export interface RateLimitState {
  status: number; // HTTP status (e.g., 429)
  retryAfterSeconds?: number | null;
  rateLimitRemaining?: number | null;
  rateLimitReset?: number | null; // epoch ms or seconds depending on server; treat as seconds-from-now if small
  requestId?: string | null;
  at: number; // timestamp
}

let current: RateLimitState | null = null;
const listeners = new Set<Listener>();

export function subscribeRateLimit(listener: Listener): () => void {
  listeners.add(listener);
  // initial push
  try {
    listener(current);
  } catch (error) {
    logger.error("Failed to call rate limit listener:", error);
  }
  return () => {
    listeners.delete(listener);
  };
}

export function notifyRateLimited(state: RateLimitState): void {
  current = state;
  for (const l of Array.from(listeners)) {
    try {
      l(current);
    } catch (error) {
      logger.error("Failed to notify rate limit listener:", error);
    }
  }
}

export function clearRateLimit(): void {
  current = null;
  for (const l of Array.from(listeners)) {
    try {
      l(current);
    } catch (error) {
      logger.error("Failed to clear rate limit listener:", error);
    }
  }
}
